<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <h2 class="brand-text text-primary ml-1">
          LaCore Connect
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            Welcome to LaCore Connect! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to your account and start the adventure
          </b-card-text>
          <div v-if="loginSucess != -1 && !tryingForm">
            <b-alert variant="success" show v-if="loginSucess">
              <div class="alert-body font-small-2">
                <p>
                  <b>Success!</b> Please wait, redirecting to dashboard...
                </p>
              </div>
            </b-alert>
            <b-alert variant="danger" show v-if="!loginSucess">
              <div class="alert-body font-small-2">
                <p>
                  <b>Error!</b> Check you entered the right credentials
                </p>
              </div>
            </b-alert>
          </div>
          <b-alert variant="warning" show v-if="tryingForm">
            <div class="alert-body font-small-2">
              <p>Logging you in....</p>
            </div>
          </b-alert>
          <b-alert variant="primary" show>
            <!-- <div class="alert-body font-small-2">
              <p>
                <small class="mr-50"
                  ><span class="font-weight-bold">Admin:</span> admin@demo.com |
                  admin</small
                >
              </p>
              <p>
                <small class="mr-50"
                  ><span class="font-weight-bold">Client:</span> client@demo.com
                  | client</small
                >
              </p>
            </div> -->
            <feather-icon
              v-b-tooltip.hover.left="
                'If you do not know your login, contact support.'
              "
              icon="HelpCircleIcon"
              size="18"
              class="position-absolute"
              style="top: 10; right: 10;"
            />
          </b-alert>

          <!-- form -->
          <validation-observer ref="loginForm" #default="{invalid}">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- email -->
              <b-form-group label="Email" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    autocomplete="username"
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    :disabled="tryingForm"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      autocomplete="current-password"
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    :disabled="tryingForm"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid || tryingForm"
              >
                Sign in
              </b-button>
            </b-form>
            <div class="text-right">
              <router-link
                class="btn btn-link"
                :to="{ name: 'ForgotPassword' }"
              >
                Forgot password?
              </router-link>
            </div>
          </validation-observer>
          <!--
          <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{ name: 'auth-register' }">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text> -->

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button variant="twitter" href="javascript:void(0)">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import useJwt from '@/auth/jwt/useJwt';
import { required, email } from '@validations';
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import { getHomeRouteForLoggedInUser } from '@/auth/utils';

export default {
  components: {
    //VuexyLogo,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      redirCount: 0,
      redirToUrl: '',
      loginSucess: -1,
      tryingForm: false,
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),

      // validation rules
      required,
      email
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
    imgUrl() {
      if (this.$store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg');
        return this.sideImg;
      }
      return this.sideImg;
    }
  },
  mounted() {
    let query = this.$route.query;
    if(query && query.redirToUrl && !query.redirToUrl.includes('login')) {
      this.redirToUrl = query.redirToUrl;
    }
    this.isLogged();
  },
  methods: {
    login() {
      this.loginSucess = -1;
      this.$refs.loginForm.validate().then(success => {
        if (success) {
        this.tryingForm = true;
          useJwt
            .login({
              userName: this.userEmail,
              password: this.password
            })
            .then(response => {
              this.tryingForm = false;
              let userData = response.data;
              userData.user = JSON.parse(JSON.stringify(userData));
              useJwt.setToken(response.data.jwtToken);
              useJwt.setRefreshToken(response.data.refreshToken);
              console.log('login response.data', response.data);
              this.$store.commit('account/setUserData', userData);

              if (!userData.userRoles.includes('brand-user')) {
                if (userData.env == 'prod') {
                  window.location.replace('https://admin.lacoreconnect.com/login?_r=' + (Math.random().toString(36).substr(2, 5)));
                } else {
                  window.location.replace('https://stagingadmin.lacoreconnect.com/login?_r=' + (Math.random().toString(36).substr(2, 5)));
                }
              }
              this.$ability.update([
                {
                  action: 'manage',
                  subject: 'all'
                }
              ]);

              this.loginSucess = true;
              setTimeout(() => {
                this.$router.push(getHomeRouteForLoggedInUser('brand-user'));
              }, 300);
            })
            .catch(error => {
              this.tryingForm = false;
              this.loginSucess = false;
              console.log('error', error);
              //this.$refs.loginForm.setErrors(error.response.data.error);
            });
        } else {
          this.tryingForm = false;
        }
      });
    },
    isLogged() {
      let $this = this;
      this.tryingForm = true;
      if (localStorage.getItem('refreshToken')) {
        this.$store
          .dispatch(
            'account/refreshToken',
            localStorage.getItem('refreshToken')
          )
          .then(response => {
            this.loginSucess = true;
            response.user = JSON.parse(JSON.stringify(response));
            this.$store.commit('account/setUserData', response);
            this.$store.dispatch('account/autoRefreshToken');
            if(this.redirToUrl && this.redirCount<5) {
              this.redirCount++;
              this.$router.push(this.redirToUrl);
            } else {
              this.$router.push(getHomeRouteForLoggedInUser('brand-user'));
            }
          })
          .catch(err => {
            console.error(err);
            localStorage.removeItem('refreshToken');
            this.tryingForm = false;
          });
      } else {
        this.tryingForm = false;
      }
    },
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
